import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';
import { useState } from 'react';
import { CROP_ASPECT_MODE_LABELS } from '../../utils/cropUtils';
import { RatioIcon } from "lucide-react"


export const CropAspectSelector = ({ aspectMode, onAspectModeChange }) => {
  const [open, setOpen] = useState(false);
  const activeLabel =
    CROP_ASPECT_MODE_LABELS.find(({ mode }) => mode === aspectMode)?.label ?? aspectMode;

  return (
    <div
      className={clsx(
        'crop-aspect-selector pointer-events-auto flex flex-col border border-yellow-600 bg-white/80 shadow-sm',
        open ? 'rounded-t-md' : 'rounded-md',
      )}
    >
      <button
        type="button"
        className={clsx(
          'flex items-center gap-1 px-2 py-1 text-start text-xs text-gray-700 bg-yellow',
          open ? 'rounded-t-md border-b border-yellow-600' : 'rounded-md',
        )}
        onClick={() => setOpen(!open)}
      >
        <RatioIcon className="h-4 w-4" /> {activeLabel}
        {open ? <ChevronUpIcon className="h-3 w-3" /> : <ChevronDownIcon className="h-3 w-3" />}
      </button>
      {open && CROP_ASPECT_MODE_LABELS.map(({ mode, label }) => {

      return aspectMode !== mode && ( 

        <button
          key={mode}
          type="button"
          onClick={() => {
            onAspectModeChange(mode)
            setOpen(false)
          }}
          className={clsx(
            'whitespace-nowrap rounded-md px-1.5 py-0 text-left text-xs font-medium transition-colors',
            aspectMode === mode ? 'font-semibold bg-yellow text-gray-900' : 'text-gray-700 hover:bg-yellow-100',
          )}
        >
          {label}
        </button>
      )})}
    </div>
  );
};
